import { Component, OnDestroy, OnInit } from '@angular/core';

interface Slide {
  image: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  private intervalId: any;

  slides: Slide[] = [
    {
      image: '/assets/img/resources/home/brokerage_banner.jpg',
      title: '',
      description: '',
      // 'LOGO ensures reliable shipping with easy tracking every step of the way.',
    },
    {
      image: '/assets/img/resources/home/logo_tracking_banner.jpg',
      title: '',
      description: '',
    },
    {
      image: '/assets/img/resources/home/logo_remit_banner.jpg',
      title: '',
      description: '',
    },
    // {
    //   image: '/assets/img/resources/home/christmas-remit-banner.jpg',
    //   title: '',
    //   description: '',
    // },
    {
      image: '/assets/img/resources/home/logo-cargo.jpg',
      title: '',
      description: '',
    },
  ];

  ngOnInit() {
    this.startAutoPlay();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  startAutoPlay() {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 10000);
  }

  stopAutoPlay() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  prevSlide() {
    this.currentSlide =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number) {
    this.currentSlide = index;
  }
}
